<template>
  <div id="app" ref="app">
    <router-view/>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'app',
  data () {
    return {
      clientHeight: '',
    }
  },
  mounted(){
    // 获取浏览器可视区域高度
    this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = () => {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: {
      handler: function (val, oldVal) {
        this.changeFixed(val)
      },
      deep: true
    },
    
  },
  methods:{
   changeFixed(clientHeight){
      this.$refs.app.style.height = clientHeight+'px';
    },
  },
  created() {
    this.clientHeight =  `${document.documentElement.clientHeight}`
  }
}
</script>
<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position:absolute;left:0;top:0;width:100%;height:100%
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
